import device from "current-device";
/**
 * Vérifier si le navigateur gère le type HTML5 donné sur un input
 * @param {string} type Type HTML5 (number, date, time,
 * datetime-local...)
 * @returns {Boolean} Retourne vrai si le navigateur gère ce type,
 * false sinon
 */
export function checkInput(type) {
    var input = document.createElement("input");
    input.setAttribute("type", type);
    var result = (input.type === type);
    if (type === 'date') {
        var notADateValue = 'not-a-date';
        input.setAttribute('value', notADateValue);
        result = (input.value !== notADateValue);
    }
    return result;
}
/**
 * Check if the browser support the maxlength attribute for an input (input or textarea)
 * @param {string} typeInput Type of input (input or textarea). textarea by default.
 * @returns {Boolean} Returns true if the input supports the maxlgenth attribute, else returns false
 */
export function checkMaxlenghtSupport(typeInput = "textarea") {
    return !("maxLength" in document.createElement(typeInput));
}
/**
 * Vérifier si le device a un petit écran (<= à  992 x 700)
 * @returns {Boolean} Retourn vrai si on est sur un petit device,
 * false sinon
 */
export function isSmallDevice() {
    return device.mobile();
}
/**
 * Check if screen could pivotate (smartphone or tablet)
 * @returns {Boolean} Return true or false
 */
export function isPhoneOrTablet() {
    return device.mobile() || device.tablet();
}
export function isIos() {
    return device.ios();
}
//# sourceMappingURL=checkFeatures.js.map